module.exports = __webpack_public_path__ + "static/img/map__logo_white.2bcbb0c8.svg";